"use client"

import type { CSSProperties } from "react"
import cn from "classnames"

import { HtmlRenderer } from "~/components/primitives/HtmlRenderer"
import { getModuleConfigProps } from "~/utils/moduleConfig"

import type { IntroductionBlockInterface } from "./IntroductionBlock.interface"
import s from "./IntroductionBlock.module.scss"

type IntroductionBlockViewProps = Omit<IntroductionBlockInterface, "id"> & {
  moduleIndex: number
  className?: string
  style?: CSSProperties
}

export const IntroductionBlockView = ({
  moduleIndex,
  eyebrow,
  content,
  config,
  className,
  style,
}: IntroductionBlockViewProps) => {
  const configProps = getModuleConfigProps(config)

  return (
    <section
      className={cn(
        s.introductionBlock,
        `stack-module-${moduleIndex}`,
        className,
      )}
      data-module="introduction-block"
      {...configProps}
      style={{ ...configProps.style, ...style }}
    >
      <div className={cn("container", "default-grid")}>
        <div className={s.inner}>
          <div className={s.eyebrowWrapper}>
            <p className={s.eyebrow}>{eyebrow}</p>
            <hr />
          </div>
          <div className={s.content}>
            {content && <HtmlRenderer html={content} element="div" />}
          </div>
        </div>
      </div>
    </section>
  )
}
